// 维护一些从 h5 页面跳转外部(包括盒子原生页)的链接
import { jumpToNative, jumpToExternal } from "@/bridge/AppJsBridge";
export default {
  methods: {
    // 跳转活动礼包
    handleGoGift () {
      const data = {
        routePath: "/gift/MineGiftActivity",
        extraParams: this.isWx ? 3 : 2, // 2 -> BT盒子活动 3-> 玩心盒子活动
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr)
    },
    // 联系客服
    onRelationServer() {
      this.$router.push({
        name: `box.customerService`,
      });
    },
    // 跳转积分商城
    handleGoPointsMall () {
      const data = {
        routePath: "/task/CreditStoreActivity",
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    // 跳转代金券
    handleGoVoucher () {
      const data = {
        routePath: "/coupon/CouponManageActivity",
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    // 跳转游戏下载
    handleGoDownload (gameId, pageType) {
      const data = {
        routePath: "/main/game/GameDetailActivity",
        extraParams: gameId,
        fromPageType: pageType || 26, // 未标记资源位
      }
      const dataStr = JSON.stringify(data)
      jumpToNative(dataStr)
    },
    handleGoRulePage (type) {
      const routeName = this.isWx ? 'box.actPlaceRule' : 'box.btActRule'
      this.$router.push({
        name: routeName,
        params: {
          type,
        },
      });
    },
    // 跳转外部链接
    handleLoadExteral (url) {
      const data = {
        routePath: url,
      }
      const dataStr = JSON.stringify(data)
      jumpToExternal(dataStr)
    },
  },
}
